import {
  SelfAttendingUserStateTypes,
  SelfAttendingUserActionTypes,
} from "./SelfAttendingUser.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SelfAttendingUserStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SelfAttendingUserReducer = (
  state: SelfAttendingUserStateTypes = INITIAL_STATE,
  action: any
): SelfAttendingUserStateTypes => {
  switch (action.type) {
    case SelfAttendingUserActionTypes.FETCH_ALL_SELF_ATTENDING_USER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SelfAttendingUserActionTypes.FETCH_ALL_SELF_ATTENDING_USER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SelfAttendingUserActionTypes.FETCH_ALL_SELF_ATTENDING_USER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SelfAttendingUserActionTypes.FETCH_ALL_SELF_ATTENDING_USER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SelfAttendingUserActionTypes.FETCH_ONE_SELF_ATTENDING_USER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SelfAttendingUserActionTypes.FETCH_ONE_SELF_ATTENDING_USER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case SelfAttendingUserActionTypes.FETCH_ONE_SELF_ATTENDING_USER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SelfAttendingUserActionTypes.FETCH_ONE_SELF_ATTENDING_USER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SelfAttendingUserReducer;
